import React from 'react';
import { Cloud, Github } from 'lucide-react';

const LandingFooter = ({ onNavigate, onLoginClick }) => (
  <footer className="lp-footer">
    <div className="lp-container">
      <div className="lp-footer-grid">
        <div className="lp-footer-brand">
          <div className="lp-brand">
            <span className="lp-brand-icon" aria-hidden="true"><Cloud size={18} /></span>
            <span className="lp-brand-text">Devorants</span>
          </div>
          <p>
            Ship Docker, Git, and ZIP deployments with auto-generated routing,
            team isolation, and real-time monitoring.
          </p>
          <div className="lp-footer-socials">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" aria-label="GitHub" onClick={(e) => e.preventDefault()}><Github size={18} /></a>
          </div>
        </div>

        <div>
          <h4>Product</h4>
          <ul>
            <li><a href="#features" onClick={(e) => onNavigate(e, 'features')}>Features</a></li>
            <li><a href="#pricing" onClick={(e) => onNavigate(e, 'pricing')}>Pricing</a></li>
            <li><a href="#docs" onClick={(e) => e.preventDefault()}>Documentation</a></li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" onClick={(e) => { e.preventDefault(); onLoginClick('hobby', false); }}>Sign in</a>
            </li>
          </ul>
        </div>

        <div>
          <h4>Legal & Resources</h4>
          <ul>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li><a href="#" onClick={(e) => e.preventDefault()}>Privacy Policy</a></li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li><a href="#" onClick={(e) => e.preventDefault()}>Terms of Service</a></li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li><a href="#" onClick={(e) => e.preventDefault()}>Status</a></li>
            <li><a href="#docs" onClick={(e) => e.preventDefault()}>Docs</a></li>
          </ul>
        </div>

        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="#community" onClick={(e) => onNavigate(e, 'community')}>Community</a></li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li><a href="#" onClick={(e) => e.preventDefault()}>Support</a></li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li><a href="#" onClick={(e) => e.preventDefault()}>Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="lp-footer-bottom">
        <span>&copy; {new Date().getFullYear()} Devorants. All rights reserved.</span>
        <div className="lp-footer-bottom-links">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={(e) => e.preventDefault()}>Privacy Policy</a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={(e) => e.preventDefault()}>Terms of Service</a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={(e) => e.preventDefault()}>Cookies</a>
        </div>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
